import {Card, CardContent, CardHeader, makeStyles, Theme} from '@material-ui/core';
import React from 'react';
import {GroupMemberListContent} from '../../Groups/GroupMemberList/GroupMemberList';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },

}));

export const BillingPartyMembersList = (props: { billingParty: BillingParty, canEdit: boolean, isAdmin: boolean, groupRef?: string}) => {
    const classes = useStyles();
    const {billingParty, canEdit, isAdmin, groupRef} = props;
    const isNewParty = billingParty.id === -1;

    return (
        <React.Fragment>
            {!isNewParty && (
                <Card className={classes.container}>
                    <CardHeader title="Billing Party Responsible For"/>
                    <CardContent>
                        <GroupMemberListContent billingPartyId={billingParty.id} isAdmin={isAdmin} canEdit={canEdit} groupRef={groupRef}/>
                    </CardContent>
                </Card>
            )}
        </React.Fragment>
    );
};

export default BillingPartyMembersList;